import { useTagStore } from "@store/tagStore";
import { getContrastTextColor } from "@utils/tagColor";

interface TagPickerProps {
  scope: string;
  value: string[];
  onSelect: (tagIds: string[]) => void;
  label?: string;
  disabled?: boolean;
}

export default function TagPicker({ scope, value, onSelect, label = "Tags", disabled = false }: TagPickerProps) {
  const tags = useTagStore((s) => s.tags)
    .filter((t) => t.scope === scope && t.active)
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleToggle = (tagId: string) => {
    if (disabled) return;
    const next = value.includes(tagId)
      ? value.filter((v) => v !== tagId)
      : [...value, tagId];
    onSelect(next);
  };

  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="text-h4 text-neutral-400">{label}</div>
      <div className="flex flex-row flex-wrap gap-1.5">
        {tags.map((tag) => {
          const isSelected = value.includes(tag.id);
          return (
            <span
              key={tag.id}
              onClick={() => handleToggle(tag.id)}
              className={`text-h3 whitespace-nowrap cursor-pointer select-none transition-opacity ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              style={{
                background: isSelected ? tag.color : "transparent",
                color: isSelected ? getContrastTextColor(tag.color) : tag.color,
                border: `1.5px solid ${tag.color}`,
                borderRadius: 30,
                padding: "3px 12px",
                lineHeight: "18px",
                opacity: isSelected ? 1 : 0.7,
              }}
            >
              {tag.name}
            </span>
          );
        })}
        {tags.length === 0 && (
          <span className="text-neutral-400 text-h3">Aucun tag disponible</span>
        )}
      </div>
    </div>
  );
}
